import React from "react";
import { connect } from "react-redux";
import { Header, RingSelector, SelectedRings } from "../../components";
import Footer from "../../components/Footer/Footer";
import "./_ConfiguratorPage.scss";
import PriceDisplay from "../../components/PriceDisplay/PriceDisplay";
import DiamondSizeSelector from "../../components/DiamondSizeSelector/DiamondSizeSelector";
import RingSelectModal from "../../components/RingSelectModal/RingSelectModal";
import { withRouter } from "react-router-dom";
import {
  selectActiveMainRing,
  selectActiveHolderRings,
} from "../../redux/actions";
import queryString from "query-string";

class ConfiguratorPage extends React.Component {
  componentDidMount() {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    this.props.selectActiveMainRing(queryParams);
    this.props.selectActiveHolderRings(queryParams);
  }

  render() {
    const {
      pageTitleText,
      backButtonText,
      forwardButtonText,
      ringsChosenText,
      activeMainRing,
      activeHolderRings,
      priceText,
      diamondSizeText,
      ringOverlayTitleText,
      ringOverlayCollectionTitleText,
      holderRingOverlayTitleText,
      holderRingOverlayCollectionTitleText,
      query,
    } = this.props;
    return (
      <div className="configurator-page ojl-configurator-page">
        <Header titleText={pageTitleText} />
        <RingSelector />
        <div className="configurator-info">
          <SelectedRings
            title={ringsChosenText}
            mainRing={activeMainRing}
            holderRing={activeHolderRings}
          />
          <div className="size-and-price">
            <DiamondSizeSelector query={query} title={diamondSizeText} />
            <PriceDisplay query={query} title={priceText} />
          </div>
        </div>
        <Footer
          backButtonText={backButtonText}
          forwardButtonText={forwardButtonText}
        />
        <RingSelectModal
          mainRingSelectTitle={ringOverlayTitleText}
          mainRingSelectSubtitle={ringOverlayCollectionTitleText}
          holderRingSelectTitle={holderRingOverlayTitleText}
          holderRingSelectSubtitle={holderRingOverlayCollectionTitleText}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ collection, configuratorPage, ring }) => {
  const { collectionsList } = collection;
  const {
    pageTitleText,
    selectRingButtonText,
    selectRingImageURL,
    selectHolderRingButtonText,
    selectHolderRingImageURL,
    ringsChosenText,
    diamondSizeText,
    priceText,
    backButtonText,
    forwardButtonText,
    ringOverlayTitleText,
    ringOverlayCollectionTitleText,
    holderRingOverlayTitleText,
    holderRingOverlayCollectionTitleText,
    defaultRingDiamondSize,
  } = configuratorPage;

  const {
    holderRings,
    mainRings,
    ringShadows,
    activeMainRing,
    activeHolderRings,
  } = ring;

  return {
    collectionsList,
    pageTitleText,
    selectRingButtonText,
    selectRingImageURL,
    selectHolderRingButtonText,
    selectHolderRingImageURL,
    ringsChosenText,
    diamondSizeText,
    priceText,
    backButtonText,
    forwardButtonText,
    ringOverlayTitleText,
    ringOverlayCollectionTitleText,
    holderRingOverlayTitleText,
    holderRingOverlayCollectionTitleText,
    holderRings,
    mainRings,
    ringShadows,
    defaultRingDiamondSize,
    activeMainRing,
    activeHolderRings,
  };
};

export default connect(mapStateToProps, {
  selectActiveMainRing,
  selectActiveHolderRings,
})(withRouter(ConfiguratorPage));
